import React, { Fragment, useEffect, useState } from 'react';
import { compose } from 'recompose';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { connect } from 'react-redux';

import {  TextInput, SelectInput, RadioInput, SwitchInput, Modal, Row, CardElement, TableElement, EmptyState, StatusChip } from '../../_Components';
import { AddButton } from '../../_Components/Buttons';
import { Button } from "@mui/material";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TelegramIcon from '@mui/icons-material/Telegram';
import { GET_ONE, provider } from '../../_utils';

const IntegationOptions = [{
    id: 'Bitrix',
    name: 'Bitrix',
},
{
    id: 'None',
    name: 'Без интеграции',
}];

const formatCheckedAt = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `проверено ${day}.${month}, ${hours}:${minutes}`;
};

const EssenceOptions = [{
    id: 'lead',
    name: 'Лид',
    hint: 'Bitrix · CRM_LEAD',
},
{
    id: 'contact',
    name: 'Контакт',
    hint: 'Bitrix · CRM_CONTACT',
},
{
    id: 'company',
    name: 'Компанию',
    hint: 'Bitrix · CRM_COMPANY',
},
{
    id: 'company_contact',
    name: 'Контакт → Компанию',
    hint: 'Связанная пара',
}];

const AddEmailForm = () => (
    <Row>
        <Field
            name="name"
            required={true}
            component={TextInput}
            label={`Название`}
            style={{width: 200}}
        />
        <Field
            name='email'
            required={true}
            component={TextInput}
            label={`E-mail`}
            style={{width: 250}}
        />
    </Row>
)

const AddTelegramForm = () => (
    <Row>
        <Field
            name="name"
            required={true}
            component={TextInput}
            label={`Название`}
            style={{width: 200}}
        />
        <Field
            name='chat'
            required={true}
            component={TextInput}
            label={`ID`}
            style={{width: 250}}
        />
    </Row>
)

const SecureOptions = [
    { id: 'ssl', name: 'SSL' },
    { id: 'tls', name: 'TLS' },
];

const AddSmtpForm = () => (
    <Fragment>
        <Row>
            <Field
                name="name"
                required={true}
                component={TextInput}
                label={`Название`}
                style={{width: 200}}
            />
            <Field
                name="sender"
                required={true}
                component={TextInput}
                label={`Отправитель`}
                style={{width: 250}}
            />
        </Row>
        <Row>
            <Field
                name="user"
                required={true}
                component={TextInput}
                label={`Логин`}
                style={{width: 200}}
            />
            <Field
                name="password"
                component={TextInput}
                type="password"
                label={`Пароль`}
                style={{width: 250}}
            />
        </Row>
        <Row>
            <Field
                name="smtp"
                component={TextInput}
                label={`SMTP`}
                style={{width: 200}}
            />
            <Field
                name="port"
                component={TextInput}
                label={`Порт`}
                style={{width: 80}}
            />
            <Field
                name="secure"
                component={SelectInput}
                options={SecureOptions}
                label={`Шифрование`}
                style={{width: 120}}
            />
            <Field
                name="auth"
                component={SwitchInput}
                label={`Авторизация`}
            />
        </Row>
    </Fragment>
)

const Settings = ({ formValues, isLoading, change, ...props }) => {
    const [isChecking, setChecking] = useState(false)
    const [checkedAt, setCheckedAt] = useState(null)
    const [emailList, setEmailList] = useState([]);
    const [telegramList, setTelegramList] = useState([]);
    const [smtpList, setSmtpList] = useState([]);
    const [emailDialog, setEmailDialog] = useState(false);
    const [telegramDialod, setTelegramDialod] = useState(false);
    const [smtpDialog, setSmtpDialog] = useState(false);
    const [emailForm, setEmailForm] = useState(null);
    const [editEmailKey, setEditEmailKey] = useState(null);
    const [telegramForm, setTelegramForm] = useState(null);
    const [editTelegramKey, setEditTelegramlKey] = useState(null);
    const [smtpForm, setSmtpForm] = useState(null);
    const [editSmtpKey, setEditSmtpKey] = useState(null);

     useEffect(() => {
        if(formValues){
            setEmailList(formValues.settings?.list?.email || []);
            setTelegramList(formValues.settings?.list?.telegram || []);
            setSmtpList(formValues.settings?.email || []);
        }
     }, [formValues])

    const removeEmail = (key) => {
        const newData = emailList;
        const newArray = [];
        newData.map( (p,i) => {
            if(i!==key) newArray.push(p);
            return p;
        });
        setEmailList(newArray);
        change(`settings.list.email`, newArray);
    }

    const removeTelegram = (key) => {
        const newData = telegramList;
        const newArray = [];
        newData.map( (p,i) => {
            if(i!==key) newArray.push(p);
            return p;
        });
        setTelegramList(newArray);
        change(`settings.list.telegram`, newArray);
    }

    const saveTelegram = (form) => {
        const newData = telegramList;
        if(editTelegramKey!==null){
            newData[editTelegramKey] = form;
            setTelegramList(newData);
        }else{
            newData.push({...form});
            setTelegramList(newData);
        }
        change(`settings.list.telegram`, newData);
        setTelegramDialod(!telegramDialod);
        setTelegramForm(null);
        setEditTelegramlKey(null);
        return;
    }

    const saveEmail = (form) => {
        const newData = emailList;
        if(editEmailKey!==null){
            newData[editEmailKey] = form;
            setEmailList(newData);
        }else{
            newData.push({...form});
            setEmailList(newData);
        }
        change(`settings.list.email`, newData);
        setEmailDialog(!emailDialog);
        setEmailForm(null);
        setEditEmailKey(null);
        return;
    }
   
    const editEmail = (form, key) => {
        setEditEmailKey(key);
        setEmailForm(form);
        setEmailDialog(!emailDialog);
    }

    const editTelegram = (form, key) => {
        setEditTelegramlKey(key);
        setTelegramForm(form);
        setTelegramDialod(!telegramDialod);
    }

    const openEmail = () => setEmailDialog(!emailDialog);
    const openTelegram = () => setTelegramDialod(!telegramDialod);

    const closeEmail = () => {
        setEmailDialog(false)
        setEmailForm(null);
    }

    const closeTelegram = () => {
        setTelegramDialod(false);
        setTelegramForm(null);
    }

    const openSmtp = () => {
        setEditSmtpKey(null);
        setSmtpForm(null);
        setSmtpDialog(true);
    }

    const closeSmtp = () => {
        setSmtpDialog(false);
        setSmtpForm(null);
        setEditSmtpKey(null);
    }

    const editSmtp = (form, key) => {
        setEditSmtpKey(key);
        const { password, ...rest } = form || {};
        setSmtpForm(rest);
        setSmtpDialog(true);
    }

    const saveSmtp = (form) => {
        if (!form || !form.sender) {
            return;
        }
        const next = [...smtpList];
        const payload = {
            ...form,
            port: form.port === '' || form.port === undefined || form.port === null ? form.port : Number(form.port)
        };
        if (editSmtpKey !== null) {
            if (!payload.password) {
                payload.password = next[editSmtpKey] && next[editSmtpKey].password;
            }
            next[editSmtpKey] = { ...next[editSmtpKey], ...payload };
        } else {
            next.push(payload);
        }
        setSmtpList(next);
        change('settings.email', next);
        closeSmtp();
    }

    const removeSmtp = (key) => {
        const next = smtpList.filter((_, i) => i !== key);
        setSmtpList(next);
        change('settings.email', next);
    }

    const checkIntegration = async () => {
        const settings = formValues?.settings?.integration?.settings || {};
        const { url, user, key } = settings;
        if (!url || !user || !key) {
            return;
        }

        const { data } = await provider(
            GET_ONE,
            '/bitrix/check',
            `${url}/${user}/${key}`
        );
        if(data){
            setChecking(true);
            setCheckedAt(new Date());
        }
    }

    const integrationType = formValues?.settings?.integration?.type;
    const isBitrix = integrationType === 'Bitrix';

    const emailHeader =  [
        {
            label: 'Имя',
            width: 20,
            value: 'name'
        },
        {
            label: 'E-mail',
            width: 20,
            value: 'email'
        }
    ];

    const telegramHeader =  [
        {
            label: 'Имя',
            width: 20,
            value: 'name'
        },
        {
            label: 'ID',
            width: 20,
            value: 'chat'
        }
    ];

    const smtpHeader = [
        { label: 'Название', width: 18, value: 'name' },
        { label: 'Отправитель', width: 22, value: 'sender' },
        { label: 'Логин', width: 20, value: 'user' },
        { label: 'SMTP', width: 18, value: 'smtp' },
        { label: 'Порт', width: 10, value: 'port' },
        { label: 'Шифрование', width: 12, value: 'secure' },
    ];

    
    return(
        <div className="pc-fill" style={{ overflow: 'auto' }}>
             {(!isLoading&&formValues)&&
                <div className="pc-split pc-split--wide pc-split--pack">
                    <div className="pc-grid">
                        <CardElement
                            title="Основное"
                            content={(
                                <div className="pc-form">
                                    <div className="pc-sect">
                                        <div className="pc-fgrid">
                                            <Field
                                                name="name"
                                                required={true}
                                                component={TextInput}
                                                label={`Название проекта`}
                                            />
                                            <Field name="customer" component="input" type="hidden" />
                                        </div>
                                    </div>
                                    <div className="pc-sect">
                                        <div className="pc-sect__t">Интеграция с CRM</div>
                                        <div className="pc-fgrid">
                                            <Field
                                                name="settings.integration.type"
                                                required={true}
                                                component={SelectInput}
                                                options={IntegationOptions}
                                                label={`Система`}
                                            />
                                            {isBitrix && (
                                                <Field
                                                    name="settings.integration.settings.url"
                                                    required={true}
                                                    component={TextInput}
                                                    label={`Домен`}
                                                    mono={true}
                                                />
                                            )}
                                            {isBitrix && (
                                                <Field
                                                    name="settings.integration.settings.user"
                                                    required={true}
                                                    component={TextInput}
                                                    label={`ID пользователя`}
                                                    mono={true}
                                                />
                                            )}
                                            {isBitrix && (
                                                <Field
                                                    name="settings.integration.settings.key"
                                                    required={true}
                                                    component={TextInput}
                                                    type="password"
                                                    label={`Ключ доступа`}
                                                    mono={true}
                                                />
                                            )}
                                        </div>
                                        {isBitrix && (
                                            <div className="pc-checkrow">
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={checkIntegration}
                                                    disabled={isLoading}
                                                >
                                                    Проверить подключение
                                                </Button>
                                                {isChecking && <StatusChip tone="ok" dot>Подключение работает</StatusChip>}
                                                {checkedAt && <span className="pc-checkrow__time">{formatCheckedAt(checkedAt)}</span>}
                                            </div>
                                        )}
                                    </div>
                                    {isBitrix && (
                                        <div className="pc-sect">
                                            <div className="pc-sect__t">Что создавать по итогу звонка</div>
                                            <Field
                                                name="settings.integration.settings.essence"
                                                required={true}
                                                component={RadioInput}
                                                variant="cards"
                                                options={EssenceOptions}
                                            />
                                            <div className="pc-togrow">
                                                <div className="pc-togrow__txt">
                                                    <b>Создавать автоматически, если сущности нет</b>
                                                    <span>Оператор не увидит вопроса — запись появится в CRM сразу после звонка.</span>
                                                </div>
                                                <Field
                                                    name="settings.integration.settings.create"
                                                    component={SwitchInput}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    </div>
                    <div className="pc-grid">
                        <CardElement
                            title="Уведомления на e-mail"
                            subheader={<StatusChip tone="mono">{emailList.length}</StatusChip>}
                            action={<AddButton handleAddClick={openEmail} label="Добавить адрес" />}
                            content={
                                emailList.length > 0
                                    ? <TableElement header={emailHeader} rows={emailList} edit={true} editFunc={editEmail} remove={true} removeFunc={removeEmail} />
                                    : <EmptyState icon={<MailOutlineIcon fontSize="small" />} title="Адресов пока нет" description="Добавьте получателей, чтобы отправлять им отчёты и оповещения по проекту." action={<AddButton handleAddClick={openEmail} label="Добавить адрес" />} />
                            }
                        />
                        <CardElement
                            title="Telegram-чаты"
                            subheader={<StatusChip tone="mono">{telegramList.length}</StatusChip>}
                            action={<AddButton handleAddClick={openTelegram} label="Добавить чат" />}
                            content={
                                telegramList.length > 0
                                    ? <TableElement header={telegramHeader} rows={telegramList} edit={true} editFunc={editTelegram} remove={true} removeFunc={removeTelegram} />
                                    : <EmptyState icon={<TelegramIcon fontSize="small" />} title="Чатов пока нет" description="Добавьте бота в чат и укажите его ID — оповещения будут приходить туда." action={<AddButton handleAddClick={openTelegram} label="Добавить чат" />} />
                            }
                        />
                        <CardElement
                            title="Почтовые ящики"
                            subheader={<StatusChip tone="mono">{smtpList.length}</StatusChip>}
                            action={<AddButton handleAddClick={openSmtp} label="Добавить ящик" />}
                            content={
                                smtpList.length > 0
                                    ? <TableElement header={smtpHeader} rows={smtpList} edit={true} editFunc={editSmtp} remove={true} removeFunc={removeSmtp} />
                                    : <EmptyState title="Ящиков пока нет" description="SMTP-ящики нужны для исходящих писем проекта." action={<AddButton handleAddClick={openSmtp} label="Добавить ящик" />} />
                            }
                        />
                    </div>
                </div>
            }
            {emailDialog&&
                <Modal 
                    title="Добавить e-mail"
                    open={emailDialog} 
                    handleSaveClick={saveEmail} 
                    handleCloseClick={closeEmail} 
                    fields={<AddEmailForm />} 
                    initial={emailForm}
                />
            }
            {telegramDialod&&
                <Modal 
                    title="Добавить Telegram Chat"
                    open={telegramDialod} 
                    handleSaveClick={saveTelegram} 
                    handleCloseClick={closeTelegram} 
                    fields={<AddTelegramForm />}
                    initial={telegramForm}
                />
            }
            {smtpDialog&&
                <Modal
                    width="md"
                    title={editSmtpKey !== null ? 'Редактировать почтовый ящик' : 'Добавить почтовый ящик'}
                    open={smtpDialog}
                    handleSaveClick={saveSmtp}
                    handleCloseClick={closeSmtp}
                    fields={<AddSmtpForm />}
                    initial={smtpForm}
                />
            }
        </div>
    )

}

const mapStateToProps = (state) => {
    const formValues = getFormValues('project')(state);
    return { 
        formValues,
    }
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'project',
        destroyOnUnmount: false, // <------ preserve form data
        forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    }),
);

export default enhance(Settings);